export const registerInViewEvent = (element, handleInView: () => void) => {
  const observer = new IntersectionObserver((entries) => {
    if (entries[0].isIntersecting) {
      handleInView();
    }
  }, {
    threshold: 0.5,
  });
  

  if (element) {
    observer.observe(element);
  }

  return () => {
    observer.disconnect();
  };
}